import { SecondaryButton } from '@designsforhealth/dfh-react-components'
import styled, { css } from 'styled-components'
import Modal from 'styled-react-modal'

import { Theme } from '../../../../../../theme'

export const Header = styled.h4`
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
  font-size: 18px;
  color: #001b36;
`

export const Description = styled.p`
  && {
    font-family: ${({ theme }) => theme.fontFamilies.roboto};
    font-size: 1rem;
    margin-bottom: 1rem;
  }
`

export const AchInformationBox = styled.div`
  background-color: ${({ theme }) => theme.colors.grayscale.white};
  border-radius: 4px;
  padding: 20px 25px 25px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  min-height: 163px;
`

export const AchInformationText = styled.p`
  && {
    font-family: ${({ theme }) => theme.fontFamilies.roboto};
    font-size: 14px;
    align-self: center;
    margin-bottom: 0;
    margin-right: 20px;
  }
`

export const AchInformationButton = styled(SecondaryButton)`
  white-space: nowrap;
`

export const AccountInformationModal = Modal.styled`${({ theme }: { theme: Theme }) => css`
  max-height: calc(100% - 32px);
  background-color: ${theme.colors.grayscale.white};
  border-radius: 10px;
  padding: 25px;
  display: flex;
  flex-direction: column;
  pointer-events: auto;
  width: 100%;
  @media (min-width: 576px) {
    max-width: 555px;
  }
})`}`

export const ModalHeader = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding-bottom: 1.5rem;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
`

export const ModalTitle = styled.h4`
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
  font-size: 18px;
  color: ${({ theme }) => theme.colors.coolGray.cool900};
  margin-bottom: 0;
  line-height: 18px;
`

export const ModalContent = styled.div`
  position: relative;
  flex: 1 1 auto;
  overflow-y: auto;
`

export const ModalText = styled.p`
  font-family: ${({ theme }) => theme.fontFamilies.roboto};
  font-size: 16px;
  margin-bottom: 24px;
  line-height: 1.17;
`

export const CloseButton = styled.button`
  padding: 1rem;
  margin: -1rem -1rem -1rem auto;
  background-color: transparent;
  border: 0;
  float: right;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: ${({ theme }) => theme.colors.grayscale.black};
  text-shadow: 0 1px 0 ${({ theme }) => theme.colors.grayscale.white};
  opacity: 0.5;
  cursor: pointer;
  &:not(:disabled):not(.disabled):hover,
  &:not(:disabled):not(.disabled):focus {
    opacity: 0.75;
  }
`

export const AchDetails = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 50%;
`

export const AchLabel = styled.h6`
  color: ${({ theme }) => theme.colors.coolGray.cool600};
  font-family: ${({ theme }) => theme.fontFamilies.roboto};
  font-weight: 400;
  font-size: 10px;
  margin-right: 0.5rem;
  margin-bottom: 0;
  margin-top: 0;
`

export const AchText = styled.p`
  && {
    color: ${({ theme }) => theme.colors.coolGray.cool900};
    font-family: ${({ theme }) => theme.fontFamilies.roboto};
    font-weight: 400;
    font-size: 14px;
    margin-bottom: 0;
  }
`

export const AchColumn = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 110px;
`

export const AchRow = styled.div`
  display: flex;
  margin-bottom: 1rem;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  &:last-of-type {
    margin-bottom: 0;
  }
`
